import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'lp2-group-class-state-locked',
  styleUrls: ['./group-class-state.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="text-center">
      <p class="theme-light mt-4 mb-3 p-3 m-0 locked-box fw-bold fs-5 lh-4 state-text">
        {{ lockedTextKey | translate }}
      </p>
      <ng-content></ng-content>
    </div>
  `,
})
export class GroupClassStateLockedComponent {
  @Input() lockedTextKey: string;
}



// WEBPACK FOOTER //
// ./ts/app/home/live-class-revamp/group-class/group-class-tile/group-class-tile-states/states/group-class-state-locked.component.ts